import { cn } from "@/lib/utils"
import { ReactNode } from "react"

export type BottombarProps = {
  className?: string
  children?: ReactNode
}

export default function Bottombar({ className, children }: BottombarProps) {
  return (
    <div
      className={cn(
        `bg-backdrop shadow-drop-shadow h-19 w-full p-4`,
        className
      )}
    >
      {children}
    </div>
  )
}
